import { IntegrationCode, IntegrationCodeType } from 'src/lib/fliko/enums/integrationCode';
import { EstateData } from 'src/lib/fliko/models/estate/estate.data';
import { RentalUnitType } from 'src/lib/fliko/models/units/unit.data';
import { ExcelFile, ExcelFileFactory } from 'src/app/shared/factories/excel-file.factory';
import { LocalizationHelper } from 'src/app/shared/helpers/localization.helper';
import { style, width } from 'src/app/shared/helpers/table.constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { UnitCommResidencyViewModel } from '../services/models/users-view-models';

type UnitsExportRows = {
  [key in IntegrationCodeType]: string;
} & {
  building: string;
  staircase: string;
  street: string;
  number: string;
  type: 'A' | 'P' | 'S';
};

export class SuperAdminUnitsExportReport {
  private exportData: UnitsExportRows[] = [];

  private readonly locHelper = new LocalizationHelper(this.ls);

  constructor(
    private ls: LocalizationService,
    private estate: EstateData,
    private apartments: UnitCommResidencyViewModel[] = [],
    private parkings: UnitCommResidencyViewModel[] = [],
    private storages: UnitCommResidencyViewModel[] = []
  ) {}

  public generateReport(): void {
    this.prepareData();
    const eg = new ExcelFileFactory();
    const hOpt = { height: 50 };

    eg.addSheet('Jednostki', residentColumns(), this.exportData, this.ls, hOpt);

    eg.saveToFile(`${this.estate.id}_jednostki_do_importu_${this.locHelper.localizeDate(Date.now(), 'dShort')}`);
  }

  private prepareData(): void {
    this.exportData = [];

    this.parseTable(this.apartments);
    this.parseTable(this.parkings);
    this.parseTable(this.storages);
  }

  private parseTable(tab: UnitCommResidencyViewModel[]): void {
    for (const data of tab) {
      const unit = data.unit;
      const codes: any = {};
      for (const key of IntegrationCode.enumValues()) {
        codes[key] = unit.unitCodes?.[key as IntegrationCodeType] ?? '';
      }
      this.exportData.push({
        building: unit.blockNumber ?? '',
        staircase: unit.staircaseNumber ?? '',
        street: unit.street ?? '',
        number: unit.number ?? '',
        type: data.type == RentalUnitType.APARTMENT ? 'A' : data.type == RentalUnitType.PARKING ? 'P' : 'S',
        ...codes
      });
    }
  }
}

function residentColumns(): ExcelFile.Column[] {
  const codesColumns: ExcelFile.Column[] = [];
  for (const val of IntegrationCode.enumValues()) {
    codesColumns.push({ header: { key: val }, key: val, width: width(200), style });
  }
  return [
    { header: { key: 'addr.blockNo' }, key: 'building', width: width(60), style },
    { header: { key: 'addr.stairNo' }, key: 'staircase', width: width(60), style },
    { header: { key: 'addr.street' }, key: 'street', width: width(250), style },
    { header: { key: 'addr.no' }, key: 'number', width: width(60), style },
    { header: { key: 'defect.unitType' }, key: 'type', width: width(40), style },
    ...codesColumns
  ];
}
